import React from "react";
import styled from "@emotion/styled";
// components
import { FormLayout } from "../components/layout/formLayout";
// utils
import { Colors } from "../components/utils/colors";

const Form05Page = () => {
  return (
    <FormLayout
      flow01="true"
      flow02="false"
      flow03="false"
      progress01="true"
      progress02="true"
      progress03="true"
      progress04="true"
      progress05="false"
      visibleBack="true"
      visibleNext="true"
      hrefBack="/form04"
      hrefNext="/confirm/"
      textBack="前の質問に戻る"
      textNext="確認画面に進む"
    >
      <SForm className="formwrap">
        <h3>お問い合わせ内容を入力してください</h3>
        <label>
          <span>*お問い合わせ内容</span>
          <textarea />
        </label>
      </SForm>
    </FormLayout>
  );
};

export default Form05Page;

const SForm = styled.div`
  h3 {
    margin-top: 4rem;
    color: ${Colors.dark};
    opacity: 0.7;
  }
  label {
    margin-top: 3rem;
    display: inline-flex;
    flex-direction: column;
    span {
      font-size: 0.8rem;
      margin-bottom: 0.25rem;
      font-weight: 500;
      opacity: 0.7;
    }
    textarea {
      width: 40rem;
      height: 10rem;
      padding: 0.5rem 1rem;
      font-size: 0.9rem;
      font-weight: 500;
      border-radius: 8px;
      border: 1px solid ${Colors.white};
      background-color: ${Colors.white};
      transition: all 0.2s;
      &:focus {
        outline: none;
        border-color: ${Colors.primary};
      }
    }
  }
  @media screen and (max-width: 599px) {
    label {
      width: 100%;
      textarea {
        width: 100%;
      }
    }
  }
`;
